import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
	constructor(m) {
		super(m);
	}

	init() {
		const item = this.el; // elemento raíz del módulo (contendrá .message)

		// Buscar mensajes dentro del contenedor y añadir botón de cierre
		const messages = item.querySelectorAll('.message');
		messages.forEach(msg => {
			// Añadir botón si no existe
			if (msg.querySelector('.notice__close')) return;

			const btn = document.createElement('button');
			btn.type = 'button';
			// Use the same class as the SCSS expects (.notice__close)
			btn.className = 'notice__close';
			btn.setAttribute('aria-label', 'Cerrar mensaje');
			btn.innerHTML = '&times;';
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				const slug = msg.getAttribute('data-slug') || null;
				// Animación y eliminación
				msg.style.transition = 'opacity 200ms ease, height 200ms ease, margin 200ms ease, padding 200ms ease';
				msg.style.opacity = '0';
				msg.style.height = '0';
				msg.style.margin = '0';
				msg.style.padding = '0';
				setTimeout(() => {
					if (msg && msg.parentNode) msg.parentNode.removeChild(msg);
					const event = new CustomEvent('art:flash:dismiss', { detail: { slug } });
					window.dispatchEvent(event);
				}, 220);
			});

			msg.appendChild(btn);

			// Dismiss when clicking anywhere on the message except interactive elements
			msg.addEventListener('click', function (e) {
				var interactive = e.target.closest('a, button, input, textarea, select, label, .notice__close');
				if (interactive) return;
				e.preventDefault();
				const slug = msg.getAttribute('data-slug') || null;
				msg.style.transition = 'opacity 200ms ease, height 200ms ease, margin 200ms ease, padding 200ms ease';
				msg.style.opacity = '0';
				msg.style.height = '0';
				msg.style.margin = '0';
				msg.style.padding = '0';
				setTimeout(() => {
					if (msg && msg.parentNode) msg.parentNode.removeChild(msg);
					const event = new CustomEvent('art:flash:dismiss', { detail: { slug } });
					window.dispatchEvent(event);
				}, 220);
			});
		});


		
	}
}